import { Icon } from '@crossnokaye/ux-common';

import { IconConfigVariant } from '@repo/sdk/models/components';

import { resolveIconComponent } from '@/features/equipment-browser/utils/resolve-icon-component';

const AnimaticIconVariants: Record<string, string> = {
  [IconConfigVariant.On]: 'fill-primary',
  [IconConfigVariant.Off]: 'fill-ckds-neutral-500',
  [IconConfigVariant.Default]: 'fill-ckds-neutral-500',
} as const;

type AnimaticIconVariant = keyof typeof AnimaticIconVariants;

interface AnimaticIconProps {
  className?: string;
  fallbackIcon?: string;
  icon: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: AnimaticIconVariant;
}

export const AnimaticIcon = ({
  className,
  fallbackIcon,
  icon,
  size = 'md',
  variant = 'default',
}: AnimaticIconProps) => {
  const IconComponent = resolveIconComponent({ fallbackIcon, icon });

  if (!IconComponent) {
    return null;
  }

  return (
    <Icon
      icon={IconComponent}
      size={size}
      variant={'transparent'}
      color={AnimaticIconVariants[variant]}
      className={className}
    />
  );
};
